import React from 'react';
import { Link } from 'react-router-dom';
import { Query } from 'react-apollo';

import queries from '../../../../graphql/queries';

import style from './index.module.scss';

const {
  topicQueries: { TOPICS },
} = queries;

function Topics() {
  return (
    <header className={style['feed']}>
      <span className={style['feed-label']}>Feed</span>
      <nav className={style['feed-list']}>
        <Query query={TOPICS}>
          {({ loading, error, data: { topics } }) => {
            if (loading) return <div>Loading...</div>;
            if (error) return <div>{JSON.stringify(error)}</div>;

            return (
              <>
                {topics.map(topic => (
                  <Link
                    to={`/topic/${topic.name}`}
                    key={topic.id}
                    className={style['feed-link']}
                  >
                    {topic.name}
                  </Link>
                ))}
              </>
            );
          }}
        </Query>
      </nav>
    </header>
  );
}

export default Topics;
